import { api } from "@/api";
import type { RfmOrderBy, RfmOrderByDirection, RfmResponse, RfmTemplateResponse, RfmSegmentCompaniesResponse } from "@/types/rfm";

export const fetchRfm = async (months = 12): Promise<RfmResponse> => {
  const response = await api.get<RfmResponse>("/rfm", { params: { months } });
  return response.data;
};

export const fetchRfmTemplate = async (): Promise<RfmTemplateResponse> => {
  const response = await api.get<RfmTemplateResponse>("/rfm/template");
  return response.data;
};

export const fetchRfmSegment = async (
  segmentId: number,
  pageNumber: number,
  pageSize: number,
  orderBy?: RfmOrderBy,
  orderByDirection?: RfmOrderByDirection,
  months = 12,
): Promise<RfmSegmentCompaniesResponse> => {
  const response = await api.get<RfmSegmentCompaniesResponse>("/rfm/segment", {
    params: { months, segmentId, pageNumber, pageSize, orderBy, orderByDirection },
  });
  return response.data;
};